export default __webpack_public_path__ + "static/media/certificate_CSS.d19cd2b8.WebP";